export default __webpack_public_path__ + "static/media/YAS0720.34I-34464_-18897_0.72108649.jpg";